module.exports = __webpack_public_path__ + "70ca36c770cea12a5bf121aec0a0ec89.png";